import {
  getPrepareNotificationsSettings,
  notificationTemplatesSettingsTree,
} from '@ui/src';
import { AllActionsSection, NotificationTemplateTypes } from '../types';

const getSectionActions = () => {
  const res: AllActionsSection = {};

  const columnsData = getPrepareNotificationsSettings(
    notificationTemplatesSettingsTree,
  );

  Object.entries(columnsData).map(
    ([key, value]) =>
      value?.pages &&
      Object.values(value.pages)
        .filter((item) => item?.actions)
        .forEach((item) => {
          res[key as NotificationTemplateTypes] = {
            ...res[key as NotificationTemplateTypes],
            ...item?.actions,
          };
        }),
  );

  return res;
};

const sectionActions: AllActionsSection = getSectionActions();

export default sectionActions;
